import { SEASON, CURIOSO_CUSTOMIZATION_LIMIT } from '../../data/constants';

const curiosoCustomizationLimit = CURIOSO_CUSTOMIZATION_LIMIT;

const curiosoState = {
  version: 1,
  introComplete: false,
  curioso: { skin: 'scaly' },
  lastEarnedAugmentation: {
    section: 'head',
    bodyPart: 'default',
  },
  /* augmentations applied to Curioso */
  augmentations: {
    head: {
      defaultEnabled: true,
      crownEnabled: false,
      unicornEnabled: false,
      hornsEnabled: false,
      antlersEnabled: false,
      aviatorhatEnabled: false,
      partyhatEnabled: false,
      flowerEnabled: false,
      acornEnabled: false,
      winterhatEnabled: false,
    },
    body: {
      defaultEnabled: true,
      lacecollarEnabled: false,
      quiltedEnabled: false,
      boltEnabled: false,
      scarfEnabled: false,
      collarEnabled: false,
    },
    back: {
      wingsEnabled: false,
      batEnabled: false,
      spikesEnabled: false,
      firespikesEnabled: false,
      flowerEnabled: false,
      starrybackEnabled: false,
      cloakEnabled: false,
    },
    legs: {
      defaultEnabled: true,
      duckfeetEnabled: false,
      starryEnabled: false,
      ghostEnabled: false,
      redshoesEnabled: false,
      flowerEnabled: false,
      fireEnabled: false,
      rainbootsEnabled: false,
      mercurybootsEnabled: false,
      octopusEnabled: false,
      spiderEnabled: false,
    },
    tail: {
      defaultEnabled: true,
      squirrelEnabled: false,
      spikeyEnabled: false,
      winterEnabled: false,
      starryEnabled: false,
      dragonEnabled: false,
      fishEnabled: false,
    },
    eyes: {
      defaultEnabled: true,
      maskEnabled: false,
      eyebrowsEnabled: false,
      aviatorgogglesEnabled: false,
      reptileEnabled: false,
      glassesEnabled: false,
      starryeyesEnabled: false,
      redcheeksEnabled: false,
      paintEnabled: false,
      leafEnabled: false,
      sunglassesEnabled: false,
    },
    face: {
      fangsEnabled: false,
      mustacheEnabled: false,
      tusksEnabled: false,
      goatbeardEnabled: false,
    },
  },
  /* Augmentations we have locked/unlocked for Curioso - Earned */
  lockedFeatures: {
    head: {
      defaultLocked: false,
      crownLocked: true,
      unicornLocked: true,
      hornsLocked: true,
      antlersLocked: true,
      aviatorhatLocked: true,
      partyhatLocked: true,
      flowerLocked: true,
      acornLocked: true,
      winterhatLocked: true,
    },
    body: {
      defaultLocked: false,
      lacecollarLocked: true,
      quiltedLocked: true,
      boltLocked: true,
      scarfLocked: true,
      collarLocked: true,
    },
    back: {
      wingsLocked: true,
      batLocked: true,
      spikesLocked: true,
      firespikesLocked: true,
      flowerLocked: true,
      starrybackLocked: true,
      cloakLocked: true,
    },
    legs: {
      defaultLocked: false,
      duckfeetLocked: true,
      starryLocked: true,
      ghostLocked: true,
      redshoesLocked: true,
      flowerLocked: true,
      fireLocked: true,
      rainbootsLocked: true,
      mercurybootsLocked: true,
      octopusLocked: true,
      spiderLocked: true,
    },
    tail: {
      defaultLocked: false,
      squirrelLocked: true,
      spikeyLocked: true,
      winterLocked: true,
      starryLocked: true,
      dragonLocked: true,
      fishLocked: true,
    },
    eyes: {
      defaultLocked: false,
      maskLocked: true,
      eyebrowsLocked: true,
      aviatorgogglesLocked: true,
      reptileLocked: true,
      glassesLocked: true,
      starryeyesLocked: true,
      redcheeksLocked: true,
      paintLocked: true,
      leafLocked: true,
      sunglassesLocked: true,
    },
    face: {
      fangsLocked: true,
      mustacheLocked: true,
      tusksLocked: true,
      goatbeardLocked: true,
    },
  },
  curiosoCustomizationLimit,
};

export const curiosoStateForDemo = {
  [SEASON.GRADE_K_1]: {
    version: 1,
    introComplete: true,
    curioso: { skin: 'scaly' },
    lastEarnedAugmentation: {
      section: 'head',
      bodyPart: 'default',
    },
    /* augmentations applied to Curioso */
    augmentations: {
      head: {
        defaultEnabled: true,
        crownEnabled: false,
        unicornEnabled: false,
        hornsEnabled: false,
        antlersEnabled: false,
        aviatorhatEnabled: false,
        partyhatEnabled: false,
        flowerEnabled: false,
        acornEnabled: false,
        winterhatEnabled: false,
      },
      body: {
        defaultEnabled: true,
        lacecollarEnabled: false,
        quiltedEnabled: false,
        boltEnabled: false,
        scarfEnabled: false,
        collarEnabled: false,
      },
      back: {
        wingsEnabled: false,
        batEnabled: false,
        spikesEnabled: false,
        firespikesEnabled: false,
        flowerEnabled: false,
        starrybackEnabled: false,
        cloakEnabled: false,
      },
      legs: {
        defaultEnabled: true,
        duckfeetEnabled: false,
        starryEnabled: false,
        ghostEnabled: false,
        redshoesEnabled: false,
        flowerEnabled: false,
        fireEnabled: false,
        rainbootsEnabled: false,
        mercurybootsEnabled: false,
        octopusEnabled: false,
        spiderEnabled: false,
      },
      tail: {
        defaultEnabled: true,
        squirrelEnabled: false,
        spikeyEnabled: false,
        winterEnabled: false,
        starryEnabled: false,
        dragonEnabled: false,
        fishEnabled: false,
      },
      eyes: {
        defaultEnabled: true,
        maskEnabled: false,
        eyebrowsEnabled: false,
        aviatorgogglesEnabled: false,
        reptileEnabled: false,
        glassesEnabled: false,
        starryeyesEnabled: false,
        redcheeksEnabled: false,
        paintEnabled: false,
        leafEnabled: false,
        sunglassesEnabled: false,
      },
      face: {
        fangsEnabled: false,
        mustacheEnabled: false,
        tusksEnabled: false,
        goatbeardEnabled: false,
      },
    },
    /* Augmentations we have locked/unlocked for Curioso - Earned */
    lockedFeatures: {
      head: {
        defaultLocked: false,
        crownLocked: false,
        unicornLocked: false,
        hornsLocked: false,
        antlersLocked: false,
        aviatorhatLocked: false,
        partyhatLocked: false,
        flowerLocked: false,
        acornLocked: false,
        winterhatLocked: false,
      },
      body: {
        defaultLocked: false,
        lacecollarLocked: false,
        quiltedLocked: false,
        boltLocked: false,
        scarfLocked: false,
        collarLocked: false,
      },
      back: {
        wingsLocked: false,
        batLocked: false,
        spikesLocked: false,
        firespikesLocked: false,
        flowerLocked: false,
        starrybackLocked: false,
        cloakLocked: false,
      },
      legs: {
        defaultLocked: false,
        duckfeetLocked: false,
        starryLocked: false,
        ghostLocked: false,
        redshoesLocked: false,
        flowerLocked: false,
        fireLocked: false,
        rainbootsLocked: false,
        mercurybootsLocked: false,
        octopusLocked: false,
        spiderLocked: false,
      },
      tail: {
        defaultLocked: false,
        squirrelLocked: false,
        spikeyLocked: false,
        winterLocked: false,
        starryLocked: false,
        dragonLocked: false,
        fishLocked: false,
      },
      eyes: {
        defaultLocked: false,
        maskLocked: false,
        eyebrowsLocked: false,
        aviatorgogglesLocked: false,
        reptileLocked: false,
        glassesLocked: false,
        starryeyesLocked: false,
        redcheeksLocked: false,
        paintLocked: false,
        leafLocked: false,
        sunglassesLocked: false,
      },
      face: {
        fangsLocked: false,
        mustacheLocked: false,
        tusksLocked: false,
        goatbeardLocked: false,
      },
    },
    curiosoCustomizationLimit,
  },
  [SEASON.GRADE_2_3]: {
    version: 1,
    introComplete: true,
    curioso: { skin: 'feathery' },
    lastEarnedAugmentation: {
      section: 'head',
      bodyPart: 'default',
    },
    /* augmentations applied to Curioso */
    augmentations: {
      head: {
        defaultEnabled: true,
        crownEnabled: false,
        unicornEnabled: false,
        hornsEnabled: false,
        antlersEnabled: false,
        aviatorhatEnabled: false,
        partyhatEnabled: false,
        flowerEnabled: false,
        acornEnabled: false,
        winterhatEnabled: false,
      },
      body: {
        defaultEnabled: true,
        lacecollarEnabled: false,
        quiltedEnabled: false,
        boltEnabled: false,
        scarfEnabled: false,
        collarEnabled: false,
      },
      back: {
        wingsEnabled: false,
        batEnabled: false,
        spikesEnabled: false,
        firespikesEnabled: false,
        flowerEnabled: false,
        starrybackEnabled: false,
        cloakEnabled: false,
      },
      legs: {
        defaultEnabled: true,
        duckfeetEnabled: false,
        starryEnabled: false,
        ghostEnabled: false,
        redshoesEnabled: false,
        flowerEnabled: false,
        fireEnabled: false,
        rainbootsEnabled: false,
        mercurybootsEnabled: false,
        octopusEnabled: false,
        spiderEnabled: false,
      },
      tail: {
        defaultEnabled: true,
        squirrelEnabled: false,
        spikeyEnabled: false,
        winterEnabled: false,
        starryEnabled: false,
        dragonEnabled: false,
        fishEnabled: false,
      },
      eyes: {
        defaultEnabled: true,
        maskEnabled: false,
        eyebrowsEnabled: false,
        aviatorgogglesEnabled: false,
        reptileEnabled: false,
        glassesEnabled: false,
        starryeyesEnabled: false,
        redcheeksEnabled: false,
        paintEnabled: false,
        leafEnabled: false,
        sunglassesEnabled: false,
      },
      face: {
        fangsEnabled: false,
        mustacheEnabled: false,
        tusksEnabled: false,
        goatbeardEnabled: false,
      },
    },
    /* Augmentations we have locked/unlocked for Curioso - Earned */
    lockedFeatures: {
      head: {
        defaultLocked: false,
        crownLocked: false,
        unicornLocked: false,
        hornsLocked: false,
        antlersLocked: false,
        aviatorhatLocked: false,
        partyhatLocked: false,
        flowerLocked: false,
        acornLocked: false,
        winterhatLocked: false,
      },
      body: {
        defaultLocked: false,
        lacecollarLocked: false,
        quiltedLocked: false,
        boltLocked: false,
        scarfLocked: false,
        collarLocked: false,
      },
      back: {
        wingsLocked: false,
        batLocked: false,
        spikesLocked: false,
        firespikesLocked: false,
        flowerLocked: false,
        starrybackLocked: false,
        cloakLocked: false,
      },
      legs: {
        defaultLocked: false,
        duckfeetLocked: false,
        starryLocked: false,
        ghostLocked: false,
        redshoesLocked: false,
        flowerLocked: false,
        fireLocked: false,
        rainbootsLocked: false,
        mercurybootsLocked: false,
        octopusLocked: false,
        spiderLocked: false,
      },
      tail: {
        defaultLocked: false,
        squirrelLocked: false,
        spikeyLocked: false,
        winterLocked: false,
        starryLocked: false,
        dragonLocked: false,
        fishLocked: false,
      },
      eyes: {
        defaultLocked: false,
        maskLocked: false,
        eyebrowsLocked: false,
        aviatorgogglesLocked: false,
        reptileLocked: false,
        glassesLocked: false,
        starryeyesLocked: false,
        redcheeksLocked: false,
        paintLocked: false,
        leafLocked: false,
        sunglassesLocked: false,
      },
      face: {
        fangsLocked: false,
        mustacheLocked: false,
        tusksLocked: false,
        goatbeardLocked: false,
      },
    },
    curiosoCustomizationLimit,
  },
  [SEASON.GRADE_4_5]: {
    version: 1,
    introComplete: true,
    curioso: { skin: 'furry' },
    lastEarnedAugmentation: {
      section: 'head',
      bodyPart: 'default',
    },
    /* augmentations applied to Curioso */
    augmentations: {
      head: {
        defaultEnabled: true,
        crownEnabled: false,
        unicornEnabled: false,
        hornsEnabled: false,
        antlersEnabled: false,
        aviatorhatEnabled: false,
        partyhatEnabled: false,
        flowerEnabled: false,
        acornEnabled: false,
        winterhatEnabled: false,
      },
      body: {
        defaultEnabled: true,
        lacecollarEnabled: false,
        quiltedEnabled: false,
        boltEnabled: false,
        scarfEnabled: false,
        collarEnabled: false,
      },
      back: {
        wingsEnabled: false,
        batEnabled: false,
        spikesEnabled: false,
        firespikesEnabled: false,
        flowerEnabled: false,
        starrybackEnabled: false,
        cloakEnabled: false,
      },
      legs: {
        defaultEnabled: true,
        duckfeetEnabled: false,
        starryEnabled: false,
        ghostEnabled: false,
        redshoesEnabled: false,
        flowerEnabled: false,
        fireEnabled: false,
        rainbootsEnabled: false,
        mercurybootsEnabled: false,
        octopusEnabled: false,
        spiderEnabled: false,
      },
      tail: {
        defaultEnabled: true,
        squirrelEnabled: false,
        spikeyEnabled: false,
        winterEnabled: false,
        starryEnabled: false,
        dragonEnabled: false,
        fishEnabled: false,
      },
      eyes: {
        defaultEnabled: true,
        maskEnabled: false,
        eyebrowsEnabled: false,
        aviatorgogglesEnabled: false,
        reptileEnabled: false,
        glassesEnabled: false,
        starryeyesEnabled: false,
        redcheeksEnabled: false,
        paintEnabled: false,
        leafEnabled: false,
        sunglassesEnabled: false,
      },
      face: {
        fangsEnabled: false,
        mustacheEnabled: false,
        tusksEnabled: false,
        goatbeardEnabled: false,
      },
    },
    /* Augmentations we have locked/unlocked for Curioso - Earned */
    lockedFeatures: {
      head: {
        defaultLocked: false,
        crownLocked: false,
        unicornLocked: false,
        hornsLocked: false,
        antlersLocked: false,
        aviatorhatLocked: false,
        partyhatLocked: false,
        flowerLocked: false,
        acornLocked: false,
        winterhatLocked: false,
      },
      body: {
        defaultLocked: false,
        lacecollarLocked: false,
        quiltedLocked: false,
        boltLocked: false,
        scarfLocked: false,
        collarLocked: false,
      },
      back: {
        wingsLocked: false,
        batLocked: false,
        spikesLocked: false,
        firespikesLocked: false,
        flowerLocked: false,
        starrybackLocked: false,
        cloakLocked: false,
      },
      legs: {
        defaultLocked: false,
        duckfeetLocked: false,
        starryLocked: false,
        ghostLocked: false,
        redshoesLocked: false,
        flowerLocked: false,
        fireLocked: false,
        rainbootsLocked: false,
        mercurybootsLocked: false,
        octopusLocked: false,
        spiderLocked: false,
      },
      tail: {
        defaultLocked: false,
        squirrelLocked: false,
        spikeyLocked: false,
        winterLocked: false,
        starryLocked: false,
        dragonLocked: false,
        fishLocked: false,
      },
      eyes: {
        defaultLocked: false,
        maskLocked: false,
        eyebrowsLocked: false,
        aviatorgogglesLocked: false,
        reptileLocked: false,
        glassesLocked: false,
        starryeyesLocked: false,
        redcheeksLocked: false,
        paintLocked: false,
        leafLocked: false,
        sunglassesLocked: false,
      },
      face: {
        fangsLocked: false,
        mustacheLocked: false,
        tusksLocked: false,
        goatbeardLocked: false,
      },
    },
    curiosoCustomizationLimit,
  },
};

export default curiosoState;
